export default __webpack_public_path__ + "static/media/CW__2899[cw].71ed5f1e.jpg";